<template>
  <div>
    <div id="modalEditarClientes" class="modal">
      <div class="modal-contenido rounded-xl p-1">
        <div class="grid grid-cols-6 justify-items-end">
          <button
            @click="clean()"
            type="button"
            class="col-start-6 end text-xl mx-2 p-1"
          >
            <a class="font-bold" href="#">X</a>
          </button>
        </div>
        <div class="w-full">
          <h4
            class="bg-gray-100 mx-9 mb-1 text-2xl shadow-xl text-black text-center mt-1 rounded divide-y divide-red-500"
          >
            Clientes
            <hr color="black" size="4" />
          </h4>
        </div>
        <!--<div
          class="border rounded-xl w-80 border-solid border-t-4 border-l-4 border-r-4 border- shadow-2xl"
        >-->
        <div class="">
          <div
            class="grid grid-cols-1 mt-15 sm:grid-cols-1 md:grid-cols-2 m-3 lg:grid-cols-3 xl:grid-cols-4 justify-center mt-2"
          >
            <div class="col-span-1">
              <strong> Tipo de documento:</strong>
              <p class="mx-2" v-if="!banderamodal">
                <strong v-if="!valor"> {{ sidtipodocumentocliente }} </strong>
              </p>

              <div
                v-if="valor"
                class="shadow mt-2 rounded mx-4 border-b-2 border-black flex"
              >
                <select
                  @click="mostrar()"
                  v-model.number="idtipodocumentocliente"
                  class="w-full h-8"
                  id="grid-state"
                >
                  <option
                    v-bind:value="tipos.idtipodocumento"
                    :key="tipos.idtipodocumento"
                    v-for="tipos of tiposdocumentos"
                  >
                    <button>
                      {{ tipos.tipodocumento }}
                    </button>
                  </option>
                </select>
              </div>
            </div>
            <div class="col-span-1">
              <strong> Cedula:</strong>
              <p class="mx-2" v-if="!banderamodal">
                <strong v-if="!valor"> {{ scedulacliente }} </strong>
              </p>

              <input
                v-model.number="cedulacliente"
                v-on:keyup="mostrar()"
                v-if="valor"
                class="appearance-none w-full mx-2 w-80 border-b-2 border-black shadow-xl block col-span-3 bg-gray-lighter text-grey-darker rounded py-1"
                id=""
                type="number"
                placeholder="Cedula "
              />
            </div>
            <div class="col-span-1 mx-2">
              <strong> primer nombre:</strong>
              <p class="mx-2" v-if="!banderamodal">
                <strong v-if="!valor"> {{ sprimernombrecliente }} </strong>
              </p>

              <input
                v-model="primernombrecliente"
                v-on:keyup="mostrar()"
                v-if="valor"
                class="appearance-none w-full mx-2 w-80 border-b-2 border-black shadow-xl block col-span-3 bg-gray-lighter text-grey-darker rounded py-1"
                id=""
                type="text"
                placeholder="Nombre 1 "
              />
            </div>
            <div class="col-span-1 mx-2">
              <strong> Segundo nombre:</strong>
              <p class="mx-2" v-if="!banderamodal">
                <strong v-if="!valor"> {{ ssegundonombrecliente }} </strong>
              </p>

              <input
                v-model="segundonombrecliente"
                v-on:keyup="mostrar()"
                v-if="valor"
                class="appearance-none w-full mx-2 w-80 border-b-2 border-black shadow-xl block col-span-3 bg-gray-lighter text-grey-darker rounded py-1"
                id=""
                type="text"
                placeholder="Nombre 2 "
              />
            </div>
            <div class="col-span-1 mx-2">
              <strong> primer apellido:</strong>
              <p class="mx-2" v-if="!banderamodal">
                <strong v-if="!valor"> {{ sprimerapellidocliente }} </strong>
              </p>

              <input
                v-model="primerapellidocliente"
                v-on:keyup="mostrar()"
                v-if="valor"
                class="appearance-none w-full mx-2 w-80 border-b-2 border-black shadow-xl block col-span-3 bg-gray-lighter text-grey-darker rounded py-1"
                id=""
                type="text"
                placeholder="Apellido 1 "
              />
            </div>
            <div class="col-span-1 mx-2">
              <strong> Segundo apellido:</strong>
              <p class="mx-2" v-if="!banderamodal">
                <strong v-if="!valor"> {{ ssegundoapellidocliente }} </strong>
              </p>

              <input
                v-model="segundoapellidocliente"
                v-on:keyup="mostrar()"
                v-if="valor"
                class="appearance-none w-full mx-2 w-80 border-b-2 border-black shadow-xl block col-span-3 bg-gray-lighter text-grey-darker rounded py-1"
                id=""
                type="text"
                placeholder="Ape..."
              />
            </div>
            <div class="col-span-1 mx-4 mt-2">
              <strong> sexo:</strong>
              <p class="mx-2" v-if="!banderamodal">
                <strong v-if="!valor"> {{ ssexo }} </strong>
              </p>

              <input
                v-if="valor"
                type="radio"
                id="m"
                value="m"
                v-model="sexo"
                @click="dos()"
              />
                  <label v-if="valor" for="uno">Masculino</label>

              <input
                v-if="valor"
                class="mx-2"
                type="radio"
                id="F"
                value="F"
                v-model="sexo"
                @click="dos()"
              />
                  <label v-if="valor" for="Dos">Femenino</label>
            </div>
            <div v-if="valor" class="col-span-1 mt-2">
              <strong> descuento :</strong>

              <div
                v-if="valor"
                class="shadow mt-2 rounded mx-4 border-b-2 border-black flex"
              >
                <select
                  v-if="valor"
                  @click="dos()"
                  v-model.number="descuento"
                  class="w-full h-8"
                  id="grid-state"
                >
                  <option disabled value="">Juana Piel</option>
                  <option
                    v-bind:value="tipos.id"
                    :key="tipos.id"
                    v-for="tipos of datosdescuentos"
                  >
                    <button>
                      <p>
                        {{ tipos.descuentojuana }}
                      </p>
                      <p>
                        {{ tipos.descuentopiel }}
                      </p>
                    </button>
                  </option>
                </select>
              </div>
            </div>
            <div class="col-span-1 mx-2">
              <strong> Direccion :</strong>
              <p class="mx-2" v-if="!banderamodal">
                <strong v-if="!valor"> {{ sdireccioncliente }} </strong>
              </p>

              <input
                v-model="direccioncliente"
                v-on:keyup="mostrar()"
                v-if="valor"
                class="appearance-none w-full mx-2 w-80 border-b-2 border-black shadow-xl block col-span-3 bg-gray-lighter text-grey-darker rounded py-1"
                id=""
                type="text"
                placeholder="Dir..."
              />
            </div>
            <div class="col-span-1 mx-2">
              <strong> Telefono :</strong>
              <p class="mx-2" v-if="!banderamodal">
                <strong v-if="!valor"> {{ stelefonocliente }} </strong>
              </p>

              <input
                v-model="telefonocliente"
                v-on:keyup="mostrar()"
                v-if="valor"
                class="appearance-none w-full mx-2 w-80 border-b-2 border-black shadow-xl block col-span-3 bg-gray-lighter text-grey-darker rounded py-1"
                id=""
                type="number"
                placeholder="Tel..."
              />
            </div>
            <div class="col-span-1 mx-2">
              <strong> Celular :</strong>
              <p class="mx-2" v-if="!banderamodal">
                <strong v-if="!valor"> {{ scelularcliente }} </strong>
              </p>

              <input
                v-model="celularcliente"
                v-on:keyup="mostrar()"
                v-if="valor"
                class="appearance-none w-full mx-2 w-80 border-b-2 border-black shadow-xl block col-span-3 bg-gray-lighter text-grey-darker rounded py-1"
                id=""
                type="number"
                placeholder="Cel..."
              />
            </div>

            <div v-if="valor" class="col-span-1 mt-2 mx-2">
              <strong> Estado cliente: :</strong>

              <label
                class="block uppercase tracking-wide inline text-grey-darker text-xs font-bold mb-2"
              >
                Estado cliente:
              </label>
              <div
                class="shadow mt-2 rounded border-b-2 border-black w-52 flex"
              >
                <label class="switch">
                  <input
                    @click="dos(), estadocliente != estadocliente"
                    v-model="estadocliente"
                    type="checkbox"
                  />
                  <span class="slider"></span>
                </label>
                <p class="text-center mx-5 font-bold" v-if="estadocliente">
                  Activo
                </p>
                <p class="text-center mx-5 font-bold" v-if="!estadocliente">
                  inactivo
                </p>
              </div>
            </div>
            <div class="col-span-1 mx-2">
              <strong> Correo :</strong>
              <p class="mx-2" v-if="!banderamodal">
                <strong v-if="!valor"> {{ semailcliente }} </strong>
              </p>

              <input
                v-model="emailcliente"
                v-on:keyup="mostrar()"
                v-if="valor"
                class="appearance-none w-full mx-2 w-80 border-b-2 border-black shadow-xl block col-span-3 bg-gray-lighter text-grey-darker rounded py-1"
                id=""
                type="text"
                placeholder="mail..."
              />
            </div>
          </div>
        </div>

        <div class="inline flex justify-center">
          <div class="col-span-1 mx-2">
            <button
              v-if="!banderamodal"
              @click="mostrarinicial()"
              type="button"
              class="w-full inline-flex justify-center mt-5 rounded-md border border-transparent shadow-sm px-2 py-1 bg-green-400 text-base font-medium text-white hover:bg-green-300 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-green-500 sm:ml-3 sm:w-auto sm:text-sm"
            >
              Modificar
            </button>
          </div>

          <div class="col-span-1 mx-2">
            <button
              @click="agregartable(), clean(), recargar()"
              type="button"
              class="w-full inline-flex justify-center mt-5 rounded-md border border-transparent shadow-sm px-2 py-1 bg-blue-600 text-base font-medium text-white hover:bg-blue-400 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-blue-500 sm:ml-3 sm:w-auto sm:text-sm"
            >
              <a href="#"> Guardar </a>
            </button>
          </div>
        </div>

        <!--</div>-->
      </div>
    </div>
  </div>
</template>

<script>
import { mapMutations, mapState } from "vuex";

export default {
  name: "modalClientes",
  data() {
    return {
      caracteristica: "",
      respuesta: null,
      idlinea: "",
      nombrelinea: "",
      value: null,
      descripcion: "",
      estado: "",
      apis: "",
      aux2: [],
      selected: "",
      descuento: [],
      idcliente: "",
      cedulacliente: 1,
      idtipodocumentocliente: "",
      primernombrecliente: "",
      segundonombrecliente: "",
      primerapellidocliente: "",
      segundoapellidocliente: "",

      direccioncliente: "",
      idpoblaciondane: 1,
      telefonocliente: "",
      celularcliente: "",
      sexo: "",
      idusuario: "",
      estadocliente: "",
      emailcliente: "",
      idusuarioNavigation: null,
      idpoblaciondaneNavigation: null,
      valor: false,
    };
  },

  methods: {
    ...mapMutations("clientes", [
      "agregartable",
      "cambio",
      "cargardatosclientes",
    ]),

    mostrar() {
      var datos = {
        idcliente: this.idcliente,
        cedulacliente: this.cedulacliente,
        idtipodocumentocliente: this.idtipodocumentocliente,
        primernombrecliente: this.primernombrecliente,
        segundonombrecliente: this.segundonombrecliente,
        primerapellidocliente: this.primerapellidocliente,
        segundoapellidocliente: this.segundoapellidocliente,
        direccioncliente: this.direccioncliente,
        idpoblaciondane: this.idpoblaciondane,
        telefonocliente: this.telefonocliente,
        celularcliente: this.celularcliente,
        iddescuentocliente: this.descuento,
        sexo: this.sexo,
        idusuario: this.idusuario,
        estadocliente: this.estadocliente,
        emailcliente: this.emailcliente,
      };

      this.cambio(datos);
    },
    async recargar() {
      setTimeout(() => {
        this.cargardatosclientes();
      }, 500);
    },

    dos() {
      this.mostrar();
      setTimeout(() => {
        this.mostrar();
      }, 500);
    },
    mostrarinicial() {
      this.idcliente = this.sidcliente;
      this.cedulacliente = this.scedulacliente;
      this.idtipodocumentocliente = this.sidtipodocumentocliente;
      this.primernombrecliente = this.sprimernombrecliente;
      this.segundonombrecliente = this.ssegundonombrecliente;
      this.primerapellidocliente = this.sprimerapellidocliente;
      this.segundoapellidocliente = this.ssegundoapellidocliente;
      this.direccioncliente = this.sdireccioncliente;
      this.idpoblaciondane = this.sidpoblaciondane;
      this.telefonocliente = this.stelefonocliente;
      this.idcliente = this.sidcliente;
      this.celularcliente = this.scelularcliente;
      this.sexo = this.ssexo;
      this.idusuario = this.sidusuario;
      this.estadocliente = this.sestadocliente;
      this.emailcliente = this.semailcliente;
      this.idusuarioNavigation = this.sidusuarioNavigation;
      this.idpoblaciondaneNavigation = this.sidpoblaciondaneNavigation;
      this.valor = true;
      this.descuento = this.sdescuento;
    },

    clean() {
      (this.caracteristica = ""),
        (this.respuesta = ""),
        (this.idlinea = ""),
        (this.nombrelinea = ""),
        (this.value = ""),
        (this.descripcion = ""),
        (this.estado = ""),
        (this.apis = ""),
        (this.aux2 = ""),
        (this.selected = ""),
        (this.idcliente = ""),
        (this.cedulacliente = ""),
        (this.idtipodocumentocliente = ""),
        (this.primernombrecliente = ""),
        (this.segundonombrecliente = ""),
        (this.primerapellidocliente = ""),
        (this.segundoapellidocliente = ""),
        (this.direccioncliente = ""),
        (this.idpoblaciondane = ""),
        (this.telefonocliente = ""),
        (this.celularcliente = ""),
        (this.sexo = ""),
        (this.idusuario = ""),
        (this.estadocliente = ""),
        (this.emailcliente = ""),
        (this.idusuarioNavigation = ""),
        (this.idpoblaciondaneNavigation = ""),
        (this.valor = false);
      this.descuento = "";
    },
  },

  computed: {
    ...mapState("clientes", [
      "sidcliente",
      "idmodal",
      "descripcionmodal",
      "scedulacliente",
      "sidtipodocumentocliente",
      "sprimernombrecliente",
      "ssegundonombrecliente",
      "sprimerapellidocliente",
      "ssegundoapellidocliente",
      "sdireccioncliente",
      "sidpoblaciondane",
      "stelefonocliente",
      "scelularcliente",
      "datosdescuentos",
      "tiposdocumentos",
      "ssexo",
      "sidusuario",
      "sestadocliente",
      "sdescuento",
      "semailcliente",
      "sidusuarioNavigation",
      "sidpoblaciondaneNavigation",
    ]),
    ...mapState([
      "elemento",
      "id",
      //"descripcion",
      "numero",
      // "idmodal",
      //"descripcionmodal",
      "banderamodal",
    ]),
  },
};
</script>
<style scoped >
.modal-contenido {
  background-color: rgb(255, 255, 255);
  width: auto;
  height: auto;

  margin: 20%;

  margin-top: 100px;
  position: center;
}
.modal {
  background-color: rgba(0, 0, 0, 0.8);
  position: fixed;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  opacity: 0;
  pointer-events: none;
  transition: all 0.1s;
}
#modalEditarClientes:target {
  opacity: 1;
  pointer-events: auto;
}

/* The switch - the box around the slider */
.switch {
  position: relative;
  display: inline-block;
  width: 60px;
  height: 28px;
  border: black;
}

/* Hide default HTML checkbox */
.switch input {
  opacity: 0;
  width: 0;
  height: 0;
}

/* The slider */
.slider {
  position: absolute;
  cursor: pointer;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: #ccc;
  -webkit-transition: 0.4s;
  transition: 0.4s;
}

.slider:before {
  position: absolute;
  content: "";
  height: 19px;
  width: 26px;
  left: 4px;
  bottom: 4px;
  background-color: white;
  -webkit-transition: 0.4s;
  transition: 0.4s;
}

input:checked + .slider {
  background-color: #2196f3;
}

input:focus + .slider {
  box-shadow: 0 0 1px #2196f3;
}

input:checked + .slider:before {
  -webkit-transform: translateX(26px);
  -ms-transform: translateX(26px);
  transform: translateX(26px);
}

/* Rounded sliders */
.slider.round {
  border-radius: 34px;
}

.slider.round:before {
  border-radius: 50%;
}
</style>

